
export class Empresa {

  codigo: string;
  nombre: string;
  direccion: string;
  tel1: string;
  tel2: string;
  tel3: string;
  logo: string;
  correo: string;
  moneda: number;
  idpais: number;
  nopais: string;
  servicio: number;
  cc_ef: string;
  cc_df: string;
  emp_idd: string;
  token: string;

  constructor() {

  this.codigo = '';
  this.nombre = '';
  this.direccion = '';
  this.tel1 = '';
  this.tel2 = '';
  this.tel3 = '';
  this.logo = '';
  this.correo = '';
  this.moneda = 0;
  this.idpais = 0;
  this.nopais = "";
  this.emp_idd = '';
  this.servicio =0;
  this.cc_ef = "";
  this.cc_df = "";
  this.token = '';

  }

}

export class CierreAdm {

ca_id: number;
ca_fecha: string;
ca_activo: number;
ca_contable: number;
emp_idd: string;
token: string;

constructor() {

  this.ca_id =0;
  this.ca_activo = -1;
  this.ca_contable = -1;
  this.ca_fecha = new Date().toISOString().slice(0, 10);
  this.emp_idd = '';
  this.token = '';

}


}


export class FiltroResumenCXC{

  id: string;
  tipodoc: string;
  numero: string;
  fdesde: string;
  fhasta: string;
  codcli: String;
  cliente: string;
  strfecha: string;
  grupo: string;
  filtro: number;
  todos: number;
  clasif: number;
  emp_idd: string;
  token: string;


  constructor() {

    this.id ='';
    this.numero ='';
    this.fdesde = '1900-01-01';
    this.fhasta = new Date().toISOString().slice(0, 10);;
    this.codcli = '';
    this.cliente = '';
    this.strfecha = 'Vence';
    this.tipodoc = '';
    this.grupo = '';
    this.filtro =0;
    this.todos =0;
    this.clasif =0;
    this.emp_idd ='';
    this.token ='';

  }

}